<template>

  <a-list style="max-height: 300px;overflow: auto;" :class="prefixCls" bordered
          :pagination="getPagination">
    <template v-for="item in getData" :key="item.id">
      <a-list-item @click="cliDetailFun(item)" style="display:flex;cursor: pointer;"
                   class="list-item">

        <a-list-item-meta>
          <template #title>
            <div class="title" style="display: flex;justify-content:start;">
              <a-typography-paragraph @click="handleTitleClick(item)"
                                      style="max-width: 90%; margin-bottom: 0 !important"
                                      :style="{ cursor: isTitleClickable ? 'pointer' : '' }"
                                      :ellipsis="$props.titleRows && $props.titleRows > 0 ? { rows: $props.titleRows, tooltip: !!item.title } : false
                " :content="getMsgContent(item.title,item)"/>
            </div>
          </template>
          <template #avatar>
            <div style="position: relative;top:5px;">
              <a-avatar style="border:1px solid #eee" v-if="item.originAvatar" class="avatar"
                        :src="getImgSrc(item.originAvatar)"/>
              <div v-else>
                <a-avatar style="background-color: #f56a00">{{ getSendUser(item.originUserName) }}
                </a-avatar>
              </div>
            </div>
          </template>

          <template #description>
            <div>
              <div class="description" v-if="item.description">
                <a-typography-paragraph style="width: 100%; margin-bottom: 0 !important"
                                        :ellipsis="
                  $props.descRows && $props.descRows > 0 ? { rows: $props.descRows, tooltip: !!item.description } : false"/>
              </div>
              <div class="datetime">22
                {{ item.createTime }}
              </div>
            </div>
          </template>
        </a-list-item-meta>
        <!-- <div>
          <i @click="removeMsg(item)" style="font-size: 20px;" class="xm-icon xmicon_shanchu"></i>
        </div> -->
      </a-list-item>

    </template>
  </a-list>
</template>
<script lang="ts">
import {msgStore} from '@/store/modules/msgStore';
import {ListItem} from './data';
import {useDesign} from '@/hooks/web/useDesign';
import {List, Avatar, Tag, Typography} from 'ant-design-vue';
import {isNumber} from 'xmgoing-utils';
import {useI18n} from 'vue-i18n';

export default defineComponent({
  components: {
    [Avatar.name]: Avatar,
    [List.name]: List,
    [List.Item.name]: List.Item,
    AListItemMeta: List.Item.Meta,
    ATypographyParagraph: Typography.Paragraph,
    [Tag.name]: Tag,
  },

  props: {
    tabName: {
      type: String,
      default: '',
    },
    list: {
      type: Array as PropType<ListItem[]>,
      default: () => [],
    },
    pageSize: {
      type: [Boolean, Number] as PropType<Boolean | Number>,
      default: 5,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    titleRows: {
      type: Number,
      default: 1,
    },
    descRows: {
      type: Number,
      default: 2,
    },
    onTitleClick: {
      type: Function as PropType<(Recordable) => void>,
    },
  },
  emits: ['update:currentPage', 'title-click'],
  setup(props, {emit}) {
    const {t} = useI18n()
    const store = msgStore()
    const {prefixCls} = useDesign('header-notify-list');
    const current = ref(props.currentPage || 1);
    const getData = computed(() => {
      const {pageSize, list} = props;
      if (pageSize === false) return [];
      let size = isNumber(pageSize) ? pageSize : 5;
      return list.slice(size * (unref(current) - 1), size * unref(current));
    });
    watch(
      () => props.currentPage,
      (v) => {
        current.value = v;
      },
    );

    // 点击消息并设置消息已读,返回选中的消息
    function cliDetailFun(item) {
      emit('title-click', item)
      store.removeMsg(item)
    }

    const isTitleClickable = computed(() => !!props.onTitleClick);
    const getPagination = computed(() => {
      const {list, pageSize} = props;
      if (pageSize > 0 && list && list.length > pageSize) {
        return {
          simple: true,
          total: list.length,
          pageSize,
          // size: 'small',
          current: unref(current),
          onChange(page) {
            current.value = page;
            emit('update:currentPage', page);
          },
        };
      } else {
        return false;
      }
    });

    function handleTitleClick(item: ListItem) {
      props.onTitleClick && props.onTitleClick(item);
    }

    function getImgSrc(imgSrc) {
      return '/api/pe-attachment/attachment/showImg/' + imgSrc;
    }

    function getSendUser(originUserName){
      return (originUserName+'').substring(0,2)
    }

    /**
     * 获取消息显示内容
     */
    function getMsgContent(itemTile,itemObj){
      try{
        const content=JSON.parse(itemObj.content);
        return content.titleContentPre+" : "+itemTile;
      }catch (e){
        return  itemTile;
      }
      return itemTile;
    }
    return {
      getMsgContent,
      getSendUser,
      getImgSrc,
      prefixCls,
      getPagination,
      getData,
      handleTitleClick,
      isTitleClickable,
      cliDetailFun,
      t
    };
  },
});
</script>
<style lang="less" scoped>
@prefix-cls: ~'@{namespace}-header-notify-list';

.@{prefix-cls} {
  &::-webkit-scrollbar {
    display: none;
  }

  .list-item:hover {
    background-color: #e6f7ff;
  }

  ::v-deep(.ant-pagination-disabled) {
    display: inline-block !important;
  }

  ::v-deep(.ant-list-item-meta-content) {
    width: calc(100% - 20px) !important;
  }

  &-item {
    padding: 6px;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.3s;

    .title {
      margin-bottom: 8px;
      font-weight: normal;

      .extra {
        float: right;
        margin-top: -1.5px;
        margin-right: 0;
        font-weight: normal;

        .tag {
          margin-right: 0;
        }
      }

      .avatar {
        margin-top: 4px;
      }

      .description {
        font-size: 12px;
        line-height: 18px;
      }

      .datetime {
        margin-top: 4px;
        font-size: 12px;
        line-height: 18px;
      }
    }
  }
}
</style>
